import { apiClient } from "services/api-client"

export const getCookies = async (tenant) => {
    return await apiClient.get(`/cookie/disclaimer/by-tenant/${tenant}`)
}

export const getCookieById = async (id) => {
    return await apiClient.get(`/cookie/disclaimer/by-id/${id}`)
}

export const deleteCookie = async (id) => {
    return await apiClient.delete(`/cookie/disclaimer/${id}`)
}

export const addCookie = async (cookie) => {
    return await apiClient.post(`/cookie/disclaimer`, cookie)
}

export const editCookie = async (id, cookie) => {
    return await apiClient.put(`/cookie/disclaimer/${id}`, cookie)
}

export const getCookieCategoryById = async (id) => {
    return await apiClient.get(`/cookie/${id}`)
}

export const getCookieConsentByTenant = async (tenant, params) => {
  let queryParam = '';
  if (params) queryParam = `?lastIds.lastId=${params.lastId}&lastIds.getFromOldDB=${params.getFromOldDB}&lastIds.disclaimerId=${params.disclaimerId}`;
  return await apiClient.get(`/cookie/disclaimer/consent/${tenant}${queryParam}`)
}

export const checkDisclaimerInstall = async (disclaimerId) => {
  return await apiClient.post(`/cookie/disclaimer/check-install/${disclaimerId}`)
}

export const createDisclaimerScheduleInstallScan = async (disclaimerId) => {
  return await apiClient.post(`/cookie/disclaimer/schedule-install-scan/${disclaimerId}`)
}

export const createDisclaimerScan = async (disclaimerId) => {
  return await apiClient.post(`/cookie/disclaimer/create-scan/${disclaimerId}`)
}